const e = 1e5;
export {
  e as AMOUNT_MULTIPLIER
};
